import queryString from 'query-string';
import { createPath, createLocation } from 'history';

import { routerReducer, LOCATION_CHANGE } from 'react-router-redux/reducer';

export { LOCATION_CHANGE } from 'react-router-redux/reducer';

export const initialState = location => {
  let newLocation = createLocation(createPath(location));

  if (location.search) {
    newLocation.query = queryString.parse(location.search);
  } else {
    newLocation.query = {};
  }

  return newLocation;
};

export default function locationReducer(state = initialState(window.location), action) {
  if (action.type === LOCATION_CHANGE) {
    let nextState = {
      ...state,
      ...routerReducer(state, action).location,
    };

    nextState.query = queryString.parse(nextState.search);
    return nextState;
  }

  return state;
}
